import { transport } from 'config/transport';

export function callApiGetClazzHolidays(clazzId, month, year) {
    return transport.get(`/mamnon/classes/${clazzId}/holidays`, { params: { holidayMonth: month } });
}
